export const CALLBACK_CONFIRMATION = "Call Back Requested";
export const CALLBACK_CONFIRMATION_MESSAGE = "A call back request has been submitted."
